export default __webpack_public_path__ + "static/product-demo-4x-5b7b174b3c4f002c58853fe4cd62341f.png";